import {apiClient} from 'core/apiClient';
import {MAP_TYPE} from 'core/constants/env';
import {Address, AddressInfo, AddressExtend} from 'types/geo';

const URL = '/service/geo';

export async function getAddressesSuggestList(payload: Address) {
    const path = `${URL}/suggest`;
    return (await apiClient.post<{data: string[]}>(path, {mapType: MAP_TYPE, ...payload})).data;
}

export async function getAddressInfoFromString(address: Address) {
    return (await apiClient.post<AddressInfo[]>(`${URL}/info`, {mapType: MAP_TYPE, ...address}))
        .data?.[0];
}

export async function createAddress(address: AddressExtend) {
    return (await apiClient.post<number>(`${URL}/add`, address)).data;
}
